import { gql } from '@apollo/client'

export const PROCESSING_TYPE_QUERY = gql`
  query processingType($id: ID!) {
    processingType(id: $id) {
      id
      projectId
      category
      intern
      title
      accessibleFor
      defaultClosingTypeId
      legalAdviceOnly
    }
  }
`
